import { useAuth } from "@/contexts/AuthContext";
import { TrustBadge } from "@/components/app/TrustBadge";

export default function SupplierProfile() {
  const { user } = useAuth();
  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow text-[hsl(var(--navy))] opacity-70 mb-2">Company profile</div>
        <h1 className="font-display text-3xl">{user?.company_name || user?.full_name}</h1>
        <div className="mt-2"><TrustBadge level="unverified"/></div>
      </div>
      <div className="surface p-5">
        <div className="font-display text-lg mb-3">Verification &amp; onboarding</div>
        <p className="text-sm text-slate-600">Full supplier onboarding — company documents, product catalog, certifications upload, bank verification, response-rate scoring and buyer feedback — is on the roadmap.</p>
        <div className="mt-4 inline-flex items-center text-xs uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-0.5">Verification workflow — Coming soon</div>
      </div>
    </div>
  );
}
